import { Component, OnInit } from '@angular/core';
import { ScheduleReportService } from '../schedule-report.service';
import { Observable, of } from 'rxjs';
// import moment from 'moment-timezone';

@Component({
  selector: 'lib-schedule-time-zone',
  templateUrl: './schedule-time-zone.component.html',
  styleUrls: ['./schedule-time-zone.component.scss']
})
export class ScheduleTimeZoneComponent implements OnInit {

  timezone$: Observable<any> = of(['ACST', 'AEST', 'AKST', 'BRT','BST', 'CAT', 'CET', 'CST', 'EST',]);

  constructor(
    public scheduleReport: ScheduleReportService,
  ) { }

  ngOnInit(): void {

    // const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // console.log(browserTimezone);
    // var zone = new Date().toLocaleTimeString('en-us',{timeZone: browserTimezone, timeZoneName:'short'}).split(' ')[2]
    // console.log(zone)
    // let timeZone = new Intl.DateTimeFormat('en-us', { timeZoneName: 'short' })
    //   .formatToParts(new Date())
    //   .find(part => part.type == "timeZoneName")
    //   .value
    // console.log(timeZone)
    // console.log(new Date().toTimeString().slice(9));
    // console.log(new Date().getTimezoneOffset() / -60);
    
    // var timeZone1 = moment().tz(moment.tz.guess());
    // console.log(timeZone1.format('z'))
  }

}
